import { useQueries } from '@maui/react-query'
import { useVTApiClient } from './client'

export const useGetPrivateAnalysesQueries = ({ analysesIds }, options = {}) => {
  const api = useVTApiClient('privateAnalyses')

  return useQueries({
    queries: analysesIds.map((id) => {
      return {
        queryKey: ['privateAnalysis', { id }],
        queryFn: () => api.details({ id }),
        refetchInterval: (data) => {
          // refetch every 5s until analysis is 'completed'
          return data?.data?.attributes?.status !== 'completed' ? 5000 : false
        },
        refetchOnWindowFocus: false,
        enabled: options.enabled !== false && id && analysesIds?.length > 0,
        ...options,
      }
    }),
  })
}
